import * as React from "react";

import "./test.scss";

import { cs }                    from "@Common/react/chain-services";
import {
    ComponentLink,
    Link,
    makeChain,
    valueHelper as value,
}                                from "@Common/react/cst2";
import {Load2}                   from "@Common/react/load2";
import {Types}                   from "@Common/types";
import {isEmpty}                 from "@Common/utils/objects";

import {consumeContext} from "@Xpresso/loaders/consume-context";
import ExpandableDiv from "../common/expandable-div";

// export const TestRoute = ({}) => cs(
//     consumeContext("apis"),
//     ({apis}) => (
//         <Test {...{apis}}/>
//     )
// );

export const TestRoute = ({}) => {
    const [responseData, setResponseData] = React.useState<Types.Apis.Payloads.Next.Authenticate.Test.Response>({} as any)
    const [loading, setLoading] = React.useState(true)
    const [status, setStatus] = React.useState("Success")
    const [statusCode, setStatusCode] = React.useState("success")
    const [statusMessage, setStatusMessage] = React.useState("")

    React.useEffect(() => {
        fetch('/next-api/authenticate/test')
        .then((response) => response.json() as Promise<Types.Apis.Payloads.Next.Authenticate.Test.Response>)
        .then((response) => {
            setResponseData(response)
            setLoading(false)
            if (response.statusCode !== 'success') {
                setStatus("Error")
                setStatusMessage(response.message)
                setStatusCode(response.statusCode.toUpperCase())
            } else if (response?.data?.samlerror) {
                setStatus("Error")
                setStatusMessage(response.data.samlerror)
                setStatusCode("SSO-218")
            } else if (response?.data?.SAMLAttributes) {
                const missing = getMissingAttributes(response)
                if (missing.length > 0) {
                    setStatus("Error")
                    setStatusMessage("Required SAML attributes are missing. Please make sure that these attributes are being sent by the IdP.")
                    setStatusCode("SSO-219")
                } else {
                    setStatus("Success")
                    setStatusMessage("SAML attributes received successfully.")
                    setStatusCode("SUCCESS")
                }
            } else {
                setStatus("Error")
                setStatusMessage(responseData?.message)
                setStatusCode(responseData.statusCode.toUpperCase())
            }
        })
        .catch((error) => {
            setLoading(false)
            console.error(error)
        })
    }, [])

    if(loading) return <div>Loading...</div>

    if(isEmpty(responseData)) return "Something went wrong! Please go back and try this action again."

    const errors = Object.keys(responseData?.data || {}).filter(attr => attr.toLowerCase().includes('error'))
    const unmapped = Object.keys(responseData?.data?.SAMLAttributes || {}).filter(attr =>
        !SAMLAttributes.map(a => a.toLowerCase()).includes(attr.toLowerCase()) && !attr.toLowerCase().includes('error')
    )
    const requiredMissing = getMissingAttributes(responseData)

    return (
        <div className="error-1y7">
            <div className={`card ${status.toLowerCase()}`} xd-qa-type="card" xd-qa-name="Details">
                <div className="header">
                    <div className="icon" xd-qa-type="icon" xd-qa-name="Alert">
                        <img alt="error" src={status.toLowerCase() === 'error' ? require("../common/alert.svg") : require("../common/check.svg")} />
                    </div>
                    <div className="code" xd-qa-type="label" xd-qa-name="Code">{statusCode}</div>
                </div>
                <div className="body">
                    <div className="message" xd-qa-type="label" xd-qa-name="Message">
                        {statusMessage}
                    </div>
                    {errors.length > 0 && (<>
                        <br/>
                        <div className="header">Errors</div>
                        {errors.map((attr, i) => (
                            <div className="line" key={i}>
                                <div className="label">{attr}:</div>
                                <ExpandableDiv {...{
                                    className: "value",
                                    content: responseData?.data[attr],
                                }} />
                            </div>
                        ))}
                    </>)}
                    {requiredMissing.length > 0 && (<>
                        <br/>
                        <div className="header">SAML Attributes Missing</div>
                        {requiredMissing.map((attr, i) => (
                            <div className="line" key={i}>
                                <div className="label">{attr}:</div>
                                <div className="value">Missing</div>
                            </div>
                        ))}
                    </>)}
                    {Object.keys(responseData?.data?.SAMLAttributes || {}).length > 0 && (<>
                        <br/>
                        <div className="header">SAML Attributes</div>
                        {SAMLAttributes.map((attr, i) => (
                            responseData?.data?.SAMLAttributes?.[attr.toLowerCase()] !== undefined ? (
                                <div className="line" key={i}>
                                    <div className="label">{attr}:</div>
                                    <ExpandableDiv {...{
                                        className: "value",
                                        content: responseData?.data?.SAMLAttributes?.[attr.toLowerCase()],
                                    }} />
                                    {/* <div className="value">{responseData?.data?.SAMLAttributes?.[attr.toLowerCase()]}</div> */}
                                </div>
                            ) : ""
                        ))}
                    </>)}
                    {unmapped.length > 0 && (<>
                        <br/>
                        <div className="header">Unmapped SAML Attributes</div>
                        {unmapped.map((attr, i) => (
                                <div className="line" key={i}>
                                    <div className="label">{attr}:</div>
                                    <ExpandableDiv {...{
                                        className: "value",
                                        content: responseData?.data?.SAMLAttributes?.[attr],
                                    }} />
                                </div>
                            ))
                        }
                    </>)}
                </div>
            </div>
            {responseData?.internalMessage && <div className="internal-message" xd-qa-type="label" xd-qa-name="Internal Message">
                Internal Message:<br/>
                <pre>{JSON.stringify(responseData?.internalMessage, null, 4)}</pre>
            </div>}
        </div>
    )
};

const getMissingAttributes = (responseData: any) => {
    if (!responseData?.data?.SAMLAttributes) return [];
    return requiredAttributes.filter(attr => {
        if (attr === 'Email') {
            // Check for either 'Email' or 'EmailAddress'
            return !(
                Object.keys(responseData?.data?.SAMLAttributes || {}).includes('email') ||
                Object.keys(responseData?.data?.SAMLAttributes || {}).includes('emailaddress')
            );
        }
        return !Object.keys(responseData?.data?.SAMLAttributes || {}).includes(attr.toLowerCase());
    });
}

const SAMLAttributes = [
    'Company',
    'UserID',
    'OrgID',
    'Fed_ID',
    'Username',
    'Email',
    'EmailAddress',
    'FirstName',
    'MiddleName',
    'LastName',
    'DirectPhone',
    'DirectPhone2',
    'License',
    'Url',
    'HeadShotUrl',
    'Role',
    'AgentDisplay1',
    'AgentDisplay2',
    'AgentDisplay3',
    'AgentDisplay4',
    'AgentDisplay5',
    'AgentDisplay6',
    'AgentDisplay7',
    'AgentDisplay8',
    'OfficeId',
    'OfficeIds',
    'PrimaryOfficeId',
    'OfficeName',
    'OfficeLegalName',
    'OfficeAddress1',
    'OfficeAddress2',
    'OfficeCity',
    'OfficeState',
    'OfficeZip',
    'OfficeCountry',
    'OfficePhone',
    'OfficeEmail',
    'OfficeFax',
    'OfficeDisplay1',
    'OfficeDisplay2',
    'OfficeDisplay3',
    'OfficeDisplay4',
    'OfficeDisplay5',
    'OfficeDisplay6',
    'OfficeDisplayCustom1',
    'OfficeDisplayCustom2',
    'OrganizationId',
    'OrganizationName',
    'RegionId',
    'RegionIds',
    'RegionName',
    'LandingPageURL',
    'PdfUrl',
    'ExternalOrderId',
    'ProductId',
    'TemplateKey',
    'QRRedirectUrl',
    'QRRedirectType',
    'CategoryAccessCodes'
];

const requiredAttributes = [
    'UserID',
    'Email',
    'FirstName',
    'LastName',
    'OfficeIds',
    'OfficeName',
];
